import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import sbLogoSource from '../../../../assets/logos/sbLogoWordOnly_160w.png'
import { getInsTokenLogo } from '../../../../routes/unauthenticated/Onboarding/insTokenDuck'
import accountUtils from '../../../../utils/account/accountUtils'
import applicationConstants from '../../../../utils/constants/application'
import { getInstokenLogoUrl, getProfilePictureUrl } from '../../../../utils/pictureUrlCreator'

class LeftDrawerHeader extends Component {
  static propTypes = {
    insTokenLogo: PropTypes.string,
    path: PropTypes.any.isRequired,
  }
  constructor(props) {
    super(props)
    this.fallbackImage = (e, fallback) => {
      if (e.target.src !== fallback) {
        e.target.src = fallback
      }
    }
  }

  render() {
    const {
      currentUser: { user },
      demoClientLogo,
      insTokenLogo,
      path,
    } = this.props
    const userExists = accountUtils.userExists(user)
    const isActive = path === '/app/profile'
    const finalLogo = demoClientLogo
      ? demoClientLogo.startsWith('http')
        ? demoClientLogo
        : `//logo.clearbit.com/${demoClientLogo}`
      : insTokenLogo
      ? getInstokenLogoUrl(insTokenLogo)
      : sbLogoSource
    return (
      <div className="text-center">
        <img
          src={finalLogo}
          alt="Steppingblocks Logo"
          style={{
            width: 160,
            margin: '15px auto 0',
            display: 'block',
            borderRadius: '0',
          }}
          onError={e => this.fallbackImage(e, sbLogoSource)}
        />
        <Link to="/app/profile">
          <img
            className="d-none d-sm-inline shadow"
            src={
              userExists
                ? getProfilePictureUrl(user.profile.picture)
                : applicationConstants.default_profile_picture_url
            }
            alt="User Pic"
            onError={e => this.fallbackImage(e, applicationConstants.default_profile_picture_url)}
            style={{ width: 85, marginTop: 15, borderRadius: '50%' }}
          />
          <div
            className="text-center"
            style={{
              marginTop: 20,
              marginBottom: 30,
              color: isActive ? '#5099de' : '#4a5f70',
              fontFamily: 'Muli',
              fontWeight: isActive ? 600 : 400,
            }}
          >
            {userExists && user.profile.name}
          </div>
        </Link>
      </div>
    )
  }
}

const mapStateToProps = _state => ({
  currentUser: _state.currentUser,
  demoClientLogo: _state.demo.logo,
  insTokenLogo: getInsTokenLogo(_state),
})

export default connect(mapStateToProps)(LeftDrawerHeader)



// WEBPACK FOOTER //
// ./src/components/ui/drawer/components/LeftDrawerHeader.js